import { ICurriculum } from '@et/types/Courses'
import { countMins, countVideos } from '@utils/genUtils'
interface IVideoStatsReturn {
  totalMins: string
  totalVideos: number
  totalModules: number
}
export const useVideoStats = (curriculum: ICurriculum[]): IVideoStatsReturn => {
  const totalModules = curriculum.length
  const totalVideos = countVideos(curriculum)
  const totalMins = countMins(curriculum)
  return {
    totalMins,
    totalVideos,
    totalModules
  };
};
